module.exports = __webpack_public_path__ + "fd0ee3e4a.png";